__turbopack_context__.v({
  "aspectBox": "Product-module-scss-module__3mrQpW__aspectBox",
  "content": "Product-module-scss-module__3mrQpW__content",
  "contentInner": "Product-module-scss-module__3mrQpW__contentInner",
  "ctaButton": "Product-module-scss-module__3mrQpW__ctaButton",
  "ctaButtons": "Product-module-scss-module__3mrQpW__ctaButtons",
  "eyebrow": "Product-module-scss-module__3mrQpW__eyebrow",
  "fade-in": "Product-module-scss-module__3mrQpW__fade-in",
  "filledLabel": "Product-module-scss-module__3mrQpW__filledLabel",
  "header": "Product-module-scss-module__3mrQpW__header",
  "headerContent": "Product-module-scss-module__3mrQpW__headerContent",
  "headerInner": "Product-module-scss-module__3mrQpW__headerInner",
  "productDescriptionWrapper": "Product-module-scss-module__3mrQpW__productDescriptionWrapper",
  "productGuideDownload": "Product-module-scss-module__3mrQpW__productGuideDownload",
  "productImage": "Product-module-scss-module__3mrQpW__productImage",
  "productImageWrapper": "Product-module-scss-module__3mrQpW__productImageWrapper",
  "productPage": "Product-module-scss-module__3mrQpW__productPage",
  "productVariant": "Product-module-scss-module__3mrQpW__productVariant",
  "productVariant--selected": "Product-module-scss-module__3mrQpW__productVariant--selected",
  "productVariantIconChecked": "Product-module-scss-module__3mrQpW__productVariantIconChecked",
  "productVariant__title": "Product-module-scss-module__3mrQpW__productVariant__title",
  "productVariants": "Product-module-scss-module__3mrQpW__productVariants",
  "productVariantsContainer": "Product-module-scss-module__3mrQpW__productVariantsContainer",
  "scale-in-check": "Product-module-scss-module__3mrQpW__scale-in-check",
  "title": "Product-module-scss-module__3mrQpW__title",
  "topSeller": "Product-module-scss-module__3mrQpW__topSeller",
  "weights": "Product-module-scss-module__3mrQpW__weights",
});
